// Ukrainian plural selection. Usage:
//   pluralUk(n, ['розв’язок', 'розв’язки', 'розв’язків'])
//   → one / few / many form depending on n.
export const pluralUk = (n, [one, few, many]) => {
    const m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
    return many;
};

export const solutionsWord = n =>
    pluralUk(n, ['розв’язок', 'розв’язки', 'розв’язків']);

// Label for the solutions disclosure. The count is spoken only when it is news:
// 4,020 of the 4,035 published problems carry exactly one solution and none
// carries more, so the old «Показати офіційний розв’язок (1)» printed the same
// parenthetical 1 on essentially every page in the archive — a constant
// pretending to be data, and a number with nothing to distinguish it from a
// problem number or a footnote. «офіційний» went the same way: nothing here is
// unofficial, so the word only made the button longer.
export const solutionsLabel = (n, open) => {
    const verb = open ? 'Сховати' : 'Показати';
    return n > 1 ? `${verb} ${n} ${solutionsWord(n)}` : `${verb} ${solutionsWord(1)}`;
};
